var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideNavTicketsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.44444C22 5.98985 20.0102 4 17.5556 4H6.44444C3.98984 4 2 5.98985 2 8.44444C2 8.98773 2.31156 9.48288 2.80135 9.71798L3.28872 9.95192C5.00702 10.7767 5.00702 13.2233 3.28872 14.0481L2.80135 14.282C2.31156 14.5171 2 15.0123 2 15.5556C2 18.0102 3.98984 20 6.44444 20H17.5556C20.0102 20 22 18.0102 22 15.5556C22 15.0123 21.6884 14.5171 21.1986 14.282L20.7113 14.0481C18.993 13.2233 18.993 10.7767 20.7113 9.95192L21.1986 9.71798C21.6884 9.48288 22 8.98773 22 8.44444Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4L10 20",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavTicketsIcon);
export default __webpack_public_path__ + "static/media/SideNavTicketsIcon.8470b2e3fb7132c4800c29b106c76041.svg";
export { ForwardRef as ReactComponent };